<template>
  <div class="overflow-hidden bg-white shadow sm:rounded-lg">
    <section>
      <div class="px-4 py-5 sm:px-6 border-t border-gray-200 ">
        <h3 class="text-lg font-medium leading-6 text-gray-900">
          Einordnung in Aufwände
        </h3>
        <p class="mt-1 max-w-2xl text-sm text-gray-500">
          Verschiedene Eckpunkte zum Einsatz der Methode.
        </p>
      </div>
      <div v-if="success" class="border-t border-gray-200 px-4 py-5 sm:p-0">
        <dl class="sm:divide-y sm:divide-gray-200">
          <div v-if="resource.relevance" class="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
            <dt class="text-sm font-medium text-gray-500">
              <RelevanceTooltip />
            </dt>
            <dd class="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
              {{ resource.relevance.trans }}
            </dd>
          </div>
          <div v-if="resource.application" class="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
            <dt class="text-sm font-medium text-gray-500">
              <ApplicationTooltip />
            </dt>
            <dd class="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
              {{ resource.application.trans }}
            </dd>
          </div>
          <div v-if="resource.investment" class="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
            <dt class="text-sm font-medium text-gray-500">
              <InvestmentTooltip />
            </dt>
            <dd class="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
              {{ resource.investment.trans }}
            </dd>
          </div>
          <div v-if="resource.commitment" class="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
            <dt class="text-sm font-medium text-gray-500">
              <CommitmentTooltip />
            </dt>
            <dd class="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
              {{ resource.commitment.trans }}
            </dd>
          </div>
          <div v-if="resource.endurance" class="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
            <dt class="text-sm font-medium text-gray-500">
              <EnduranceTooltip />
            </dt>
            <dd class="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
              {{ resource.endurance.trans }}
            </dd>
          </div>
          <div v-if="resource.recurrence" class="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6 hidden">
            <dt class="text-sm font-medium text-gray-500">
              <RecurrenceTooltip />
            </dt>
            <dd class="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
              {{ resource.recurrence.trans }}
            </dd>
          </div>
          <div v-if="resource.continuation" class="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
            <dt class="text-sm font-medium text-gray-500">
              <ContinuationTooltip />
            </dt>
            <dd class="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
              {{ resource.continuation.trans }}
            </dd>
          </div>
          <div v-if="resource.expansion" class="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
            <dt class="text-sm font-medium text-gray-500">
              <ExpansionTooltip />
            </dt>
            <dd class="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
              {{ resource.expansion.trans }}
            </dd>
          </div>
          <div v-if="resource.realization" class="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
            <dt class="text-sm font-medium text-gray-500">
              <RealizationTooltip />
            </dt>
            <dd class="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
              <p v-for="value in resource.realization" :key="value">
                {{ value.trans }}
              </p>
            </dd>
          </div>
        </dl>
      </div>
      <div v-if="failure" class="border-t border-gray-200 px-4 py-5 sm:p-0">
        <div class="px-4 py-5 sm:px-6">
          <p class="mt-1 max-w-2xl text-sm text-gray-500">
            Für diese Methode wurde noch keine Einordnung vorgenommen.
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useRetrieveResource } from '@/client/actions';

const props = defineProps({practice: Object});

const parent = computed(() => props.practice.id);
const target = computed(() => '/api/practices/' + parent.value + '/context');

const { retrieve, retrieving, resource, success, failure } = useRetrieveResource(target);

const onMount = onMounted(() => retrieve());
</script>

<style scoped>
.info-icon
{
  @apply h-5 w-5 inline-block;
  @apply text-gray-400;
}
</style>
